import { Association } from "./types";

export const findAssociationIndex = (
  associations: Association[],
  association: Omit<Association, "amount">
) => {
  if (association.submissionId) {
    return associations.findIndex(
      (item) =>
        item.submissionId === association.submissionId &&
        !item.reportId &&
        !item.facilityId
    );
  }

  if (association.reportId) {
    return associations.findIndex(
      (item) => item.reportId === association.reportId && !item.facilityId
    );
  }

  if (association.facilityId) {
    return associations.findIndex(
      (item) => item.facilityId === association.facilityId && !item.reportId
    );
  }

  return -1;
};
